import { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

export function Reports() {
  const [reports, setReports] = useState<any[]>([])
  const navigate = useNavigate()
  
  useEffect(() => {
    fetchReports()
  }, [])
  
  const fetchReports = async () => {
    try {
      const response = await axios.get('https://fd0oqhf3la.execute-api.us-east-1.amazonaws.com/prod/reports')
      setReports(response.data.reports || [])
    } catch (error) {
      console.error('Failed to fetch reports:', error)
    }
  }
  
  const ingestNews = async (ticker: string) => {
    try {
      await axios.post('https://fd0oqhf3la.execute-api.us-east-1.amazonaws.com/prod/collect/news', { ticker })
      fetchReports()
    } catch (e) {
      console.error('Failed to ingest news', e)
    }
  }
  
  const orchestrateAnalyze = async (ticker: string) => {
    try {
      await axios.post('https://fd0oqhf3la.execute-api.us-east-1.amazonaws.com/prod/orchestrate/analyze', { ticker })
    } catch (e) {
      console.error('Failed to start orchestrated analysis', e)
    }
  }
  
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-4">Analysis Reports</h2>
        
        {reports.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <p className="text-lg">No reports yet.</p>
            <p className="text-sm mt-2">Run an analysis to generate your first report!</p>
          </div>
        ) : (
          <div className="space-y-2">
            {reports.map((report) => (
              <div
                key={report.report_id || report.reportId || report.id}
                className="p-4 border rounded-lg hover:bg-gray-50"
              >
                <div className="flex justify-between items-center">
                  <div className="cursor-pointer" onClick={() => navigate(`/reports/${report.report_id || report.reportId || report.id}`)}>
                    <span className="font-bold">{report.ticker}</span>
                    <span className="ml-3 text-gray-600">{report.recommendation || '—'}</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <span className="text-gray-500 text-sm">{new Date(report.generated_at || report.generatedAt || report.created_at).toLocaleString()}</span>
                    {report.download_url && (
                      <a
                        href={report.download_url}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Markdown
                      </a>
                    )}
                    <button onClick={() => ingestNews(report.ticker)} className="text-sm text-gray-700 border px-2 py-1 rounded" onMouseDown={(e) => e.stopPropagation()}>Ingest News</button>
                    <button onClick={() => orchestrateAnalyze(report.ticker)} className="text-sm text-blue-700 border px-2 py-1 rounded" onMouseDown={(e) => e.stopPropagation()}>Analyze</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

